import { useEffect, useRef } from "react";


export const usePooling = (callback, delay, pause = false) => {
    const savedCallback = useRef();

    // latest callback function
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Pooling interval
    useEffect(() => {
        function pool() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(pool, delay);
            if(pause){
                clearInterval(id);
            }
            return () => clearInterval(id);
        }
    }, [delay, pause]);
}